/**
 * Get the position index of the slide for the React Spring configs
 * if position is 0, the slide will move faster than if position is equal to items.length
 * @returns [Int] Position between 0 and items.length
 */
export const getSlideConfigPositionIndex = ({
	loop,
	currentSlideIndex,
	positionIndex,
	dx,
	previousDirection,
	items,
}) => {
	if (loop) {
		const direction = dx === 0 ? previousDirection.current : dx; // Fix for `dx` being sometimes `-0` or `0`
		return direction >= 0
			? positionIndex
			: items.length - positionIndex - 1;
	} else {
		return dx > 0
			? positionIndex - currentSlideIndex
			: currentSlideIndex - positionIndex;
	}
};
